import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["Banner"] */ "/app/src/components/banner/Banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumb"] */ "/app/src/components/breadcrumb/Breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CardComplex"] */ "/app/src/components/cards/CardComplex/CardComplex.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Cards"] */ "/app/src/components/cards/Cards.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/contact-form/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CrossSale"] */ "/app/src/components/cross-sale/CrossSale.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomComponent"] */ "/app/src/components/custom-component/CustomComponent.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/faq/FaqCard/FaqCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FaqCategories"] */ "/app/src/components/faq/FaqCategories/FaqCategories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Partners"] */ "/app/src/components/partners/Partners.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Review"] */ "/app/src/components/review/Review.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Stepper"] */ "/app/src/components/steppers/Stepper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DestinationDetails"] */ "/app/src/components/ui/DestinationDetails/DestinationDetails.tsx");
